module.exports = __webpack_public_path__ + "static/media/tooltip_roundabout_right.31d0e361.png";